module.exports = __webpack_public_path__ + "img/work_environment2.df06954c.png";